module.exports = __webpack_public_path__ + "static/media/Agree.fb5540be.mp3";